<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('update_rider') }}
      v-divider.basic300
      v-card-text.px-4.pb-0
        v-form(ref="form")
          .name
            div.mt-4.label.basic600--text.text-uppercase {{ $t('name.label') }}
            v-text-field.mt-2(solo flat background-color="basic200" height="40" v-model='name' :label="$t('name.label')" :placeholder="$t('name.placeholder')" outlined dense persistent-hint :rules="rules.not_empty")
              template(v-slot:label)
                .p1.basic600--text {{ $t('name.text') }}
          .phone
            div.label.basic600--text.text-uppercase {{ $t('phone.label') }}
            y-phone-input.my-4(v-model="phone")
          .vehicle-no
            div.label.basic600--text.text-uppercase {{ $t('vehicle_no.title') }}
            v-text-field.mt-2(solo flat background-color="basic200" height="40" v-model='vehicleNo' :label="$t('vehicle_no.label')" :placeholder="$t('vehicle_no.placeholder')" outlined dense persistent-hint  :rules="rules.not_empty")
              template(v-slot:label)
                .p1.basic600--text {{ $t('vehicle_no.text') }}
      v-card-actions
        v-spacer
        v-btn.button-Aa-small(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-small.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          div(v-if="rider") {{ $t('update') }}
          div(v-else) {{ $t('add') }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UpdateRiderDialog',
  props: ['open', 'rider'],
  data: () => ({
    name: null,
    phone: null,
    vehicleNo: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    phoneSanitized () {
      let phone = this.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
  },
  mounted () {
    if (this.rider) {
      this.name = this.rider.name
      this.phone = this.rider.phone
      this.vehicleNo = this.rider.vehicle_no
    }
  },
  methods: {
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData();
      params.set('company', this.company.id)
      params.set('name', this.name)
      params.set('phone', this.phoneSanitized)
      params.set('vehicle_no', this.vehicleNo)
      if (this.rider) {
        this.axios.put(`/shipping/riders/${this.rider.id}/`, params)
        .then(resp => {
          this.$emit('edited', resp.data)
          this.showModal = false
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/shipping/riders/`, params)
        .then(resp => {
          this.$emit('added', resp.data)
          this.showModal = false
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "update_rider": "Update Rider",
    "name": {
      "label": "Rider name",
      "placeholder": "Write your rider name here",
      "text": "Enter Rider Name"
    },
    "phone": {
      "label": "Rider phone",
      "placeholder": "Write your rider phone no here"
    },
    "vehicle_no": {
      "title": "Plate Number",
      "text": "Register Rider Plate Number",
      "label": "Rider vehicle no",
      "placeholder": "Write your rider vehicle no here"
    }
  },
  "id": {
    "update_rider": "Perbarui Rider",
    "name": {
      "label": "Nama rider",
      "placeholder": "Tulis nama rider di sini",
      "text": "Tulis nama rider"
    },
    "phone": {
      "label": "Nomor HP Rider",
      "placeholder": "Tulis Nomor HP Rider"
    },
    "vehicle_no": {
      "title": "Nomor Plat",
      "text": "Daftar Nomor Plat Rider",
      "label": "Nomor Plat Rider",
      "placeholder": "Tulis nomor plat rider di sini"
    }
  }
}
</i18n>
